// extracted by mini-css-extract-plugin
module.exports = {"page-secondary-color":"#FFFFFF","pageSecondaryColor":"#FFFFFF","container":"_2v5lz","title":"_27Prp","back":"_4LWNN","close":"_3QE-S"};